import { logout } from '../../../../../global-state/auth-state';
import { closeLoadingPage } from '../../../../../global-state/show-loading-page';
import { fetchJsonWithToken } from './fetch-json-with-token';
import { HttpMethod } from './types/enum/http-method';
import { FetchRawResultType } from './types/fetch-raw-result-type';

export const fetchJsonWithTokenCheck = async ({
  token,
  uri,
  method,
  body
}: Readonly<{
  token: string;
  uri: string;
  method: HttpMethod;
  body?: object;
}>): Promise<FetchRawResultType> => {
  const result = await fetchJsonWithToken({ token, uri, method, body });

  // unauthorized
  if (result.statusCode === 401) {
    // 全てのローディング状態を強制的にクリア
    console.warn('Session expired - clearing all loading states');
    for (let i = 0; i < 20; i++) {
      closeLoadingPage();
    }
    
    // ログアウト処理を少し遅延させて、ローディング状態のクリアを確実にする
    setTimeout(() => {
      logout();
    }, 100);
  }

  return result;
};
